import { styled } from '@mui/material';

import { Size, Color } from '@components/Chip';
import ActionButton from '@components/ActionButton';

import { propsFilter } from '@utils/propsFilter';

import { SIZE, COLOR } from './constants';

export const sxStyles = {
  title: {
    fontSize: '0.813rem',
  },
};

export const StyledChip = styled(ActionButton, {
  shouldForwardProp: propsFilter(['chipSize', 'chipColor']),
})<{ chipSize: Size; chipColor: Color }>(({ chipSize, chipColor }) => ({
  padding: '0 0.75rem',
  color: COLOR[chipColor].dark,
  background: COLOR[chipColor].background,
  borderRadius: '8px',
  fontSize: '0.813rem',
  minHeight: SIZE[chipSize],
  height: SIZE[chipSize],
  border: `1px solid ${COLOR[chipColor].main}`,

  '&:hover': {
    background: COLOR[chipColor].hover,
  },

  '& > svg:first-of-type': {
    marginLeft: '4px',
    fill: COLOR[chipColor].main,
  },
}));
